import { useData } from '@/components';
import { useEcomStoreSelector } from '@/data';
import { Store, TreezStore } from '@/types';

interface ISelectedStore {
  store: TreezStore | undefined;
}

interface IGapCommerceStore {
  store: Store | undefined;
}

const useSelectedStore = (): ISelectedStore => {
  const { treezStores } = useData();
  const { treez_store_name } = useEcomStoreSelector(['treez_store_name']);

  return {
    store: treezStores?.find(store => store?.short_name === treez_store_name),
  };
};

const useGapCommerceStore = (): IGapCommerceStore => {
  const { store } = useData();

  return {
    store,
  };
};

export { useSelectedStore, useGapCommerceStore };
